import React from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Form, Input, Space, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardChecksTypeEnum } from "@payping/api";
import { DashboardRoutes } from "@/router/constant";
import { useHandleNavigationURL, useSaveToRedux } from "../../utils";
import { selectAtom } from "jotai/utils";
import { settingsBusinessAtom } from "@/mobile/Settings/state";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditOfficialBusinessName: React.FC = () => {
  const { t } = useAppTranslation();
  const [form] = Form.useForm();
  const checks = useAppSelector((state) => state.user.checks);
  const isBusinessDisabled = checks?.businessStatus === DashboardChecksTypeEnum.Confirmed;

  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const companyNameApi = useAppSelector((state) => state.user.businessInfo?.companyName);

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        placement={"bottom"}
        open={true}
        height={"100%"}
        title={`${t("edit")} / ${t("settings.business.officialBusinessName")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Space direction={"vertical"}>
          <Form
            onFinish={({ companyName }) =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.officialBusinessSabtNumber.url,
                nextUrlForEdit: DashboardRoutes.settings.mEditBusiness.officialBusinessSabtNumber.url,
                fieldName: "companyName",
                fieldValue: companyName,
                setIsDrawerOpen: () => {},
              })
            }
            form={form}
            initialValues={{ companyName: mobileFormEditState.companyName ?? companyNameApi }}
          >
            <Form.Item label={t("settings.business.officialBusinessName")} name="companyName">
              <Input disabled={!form.getFieldValue("companyName") ? false : isBusinessDisabled} />
            </Form.Item>
          </Form>
          <Typography.Text type={"secondary"}>{t("mobileEditPersonal.nameDesc")}</Typography.Text>
        </Space>
      </Drawer>
      <EditActionButtons onAccept={form.submit} acceptText={t("next")} />
    </>
  );
};

export default MobileEditOfficialBusinessName;
